import React, { useEffect, useState } from "react";
import { fetchData, fetchFormData } from "../../utils/options";
import { useParams, Link } from "react-router-dom";
import Header from "../shared/header/Header";
import NavigationMenu from "../shared/navigationMenu/NavigationMenu";
import PageHeader from "../shared/pageHeader/PageHeader";
// import Content2Header from "./Content2Header";
import { useNavigate } from "react-router-dom";
import { BaseUrl, ImageUrl } from "../..";
import { FiBookOpen, FiSave, FiVideo } from "react-icons/fi";
const Library = () => {
  const { id } = useParams();

  const [activity, setActivity] = useState([]);
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    if (localStorage.getItem("access_token") === null) {
      navigate("/");
    }
  }, []);

  const fetchActivityByStudentId = async (id) => {
    const formData = new FormData();
    formData.append("student_id", id); //  use id here

    try {
      const result = await fetchFormData(
        `student/activity/getbyid`, //  use id here
        formData,
        "POST"
      );

      if (result?.success || result?.code === 200) {
        setActivity(result.data);
      }
    } catch (error) {
      console.error("Error fetching content:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchActivityByStudentId(id);
  }, [id]);

  const statusLabel = {
    0: "Pending",
    1: "Admin Approval Required",
    2: "Approved",
    3: "Rejected",
  };





  const formatDate = (dateString) => {
    if (!dateString) return "-";
    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();

    return `${day}-${month}-${year}`;
  };

  return (
    <>
      <>
        <Header />
        <NavigationMenu />
        <main className="nxl-container">
          <div className="nxl-content">
            <PageHeader />
            <div className="main-content">
              <div className="card shadow-sm border-0 mb-4 p-2">
                <div
                  className="card-header py-3"
                  style={{ backgroundColor: "#0e606e" }}
                >
                  <h5 className="mb-0 text-white">Student Activity</h5>
                  
                </div>

                <div className="card-body p-3 fw-bold">
                  {/* Student Details Table */}

                  <table className="table table-bordered table-hover align-middle">
                    <thead className="table text-white">
                      <tr>
                        <th>Course </th>
                        <th>Semester</th>
                        <th>Subject Name</th>
                        <th>Chapter Name</th>
                        <th>Title</th>
                        <th>Thumbnail</th>
                          <th>Content</th>
                      </tr>
                    </thead>

                    <tbody>
                      {activity && activity.length > 0 ? (
                        activity.map((item, index) => (
                          <tr key={index}>
                            <td>{item?.course_name || "-"}</td>
                            <td>{item?.semester_name || "-"}</td>
                            <td>{item?.subject_name || "-"}</td>
                            <td>{item?.chapter_name || "-"}</td>
                            <td>{item?.title || "-"}</td>
                            {/* Thumbnail */}
                            <td>
                              {item?.thumbnail_url ? (
                                <img
                                  src={`${item?.thumbnail_url}`}
                                  alt="thumb"
                                  style={{
                                    width: "60px",
                                    height: "40px",
                                    objectFit: "cover",
                                    borderRadius: "4px",
                                  }}
                                />
                              ) : (
                                "-"
                              )}
                            </td>
                            {/*  ACTION ICONS */}
        <td className="d-flex gap-2 mt-3 fw-bold ">
          <FiBookOpen
            className="cursor-pointer"
            title="Edit Notes"
            onClick={() =>
              navigate(`/student/edit-notes/${item?.content_id}`)
            }
          />
          <FiSave
            className="cursor-pointer"
            title="Edit PDF"
            onClick={() =>
              navigate(`/student/edit-pdf/${item?.content_id}`)
            }
          />
          <FiVideo
            className="cursor-pointer"
            title="Edit Video"
            onClick={() =>
              navigate(`/student/edit-video/${item?.content_id}`)
            }
          />
        </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan={4} className="text-center text-muted">
                            No activity found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </main>
      </>
    </>
  );
};

export default Library;
